/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { Component, ReactElement } from "react";
import "./index.less";
import Loading from "react-loading";
import ReactDOM from "react-dom";
interface Props {
  visible: boolean;
  text: string;
}

export function Loader(props: Props) {
  const { visible, text } = props;
  return visible ? (
    <div className="loading-wrapper3">
      <div className="loading-center3">
        {text ? <p className="loading-text3">{text}</p> : ""}
      </div>
    </div>
  ) : null;
}

export interface LoadingOpt {
  text: string;
  duration?: number;
  cbk?: Function;
}
//暂时没有props，先预留位置
interface LoadingProps {
  container: HTMLElement;
  text: string;
  [x: string]: any;
}
export default class FullLoading extends Component<LoadingProps, {}> {
  static _container: HTMLElement | null;
  static _timer: number = 0;
  static show = function(opt: LoadingOpt) {
    if (FullLoading._container) return;
    const div = document.createElement("div");
    document.body.appendChild(div);
    FullLoading._container = div;
    console.log("FullLoading", opt);
    ReactDOM.render(
      <FullLoading
        container={div}
        text={opt.text}
      />,
      div
    );
    if (opt.duration) {
      FullLoading._timer = window.setTimeout(() => {
        FullLoading.hide();
      }, opt.duration);
    }
  };
  static hide = function() {
    if (FullLoading._container) {
      const div = FullLoading._container;
      const unmountRes = ReactDOM.unmountComponentAtNode(div);
      if (unmountRes && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }
    FullLoading._container = null;
  };

  render(): ReactElement {
    return ReactDOM.createPortal(
      <Loader
        visible={true}
        text={this.props.text}
      />,
      this.props.container
    );
  }
}
